import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetMailSablonuListRequest } from '../models/request/mailSablonu/GetMailSablonuListRequest';

/** Ayarlar > Mail Şablonları (teslim bilgilendirme maili vb.). */
export class MailSablonuService {
    static async getMailSablonuList(inputObj: GetMailSablonuListRequest) {
        try {
            console.log('SERVICE CALL - GetMailSablonuList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/GetMailSablonuList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportMailSablonuList(inputObj: GetMailSablonuListRequest) {
        try {
            console.log('SERVICE CALL - ExportMailSablonuList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/ExportMailSablonuList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getMailSablonuById(_id: string) {
        try {
            var inputObj = { id: _id };

            console.log('SERVICE CALL - GetMailSablonuById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/GetMailSablonuById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async updateMailSablonu(_mailSablonuId: string, _konu: string, _govde: string) {
        try {
            var inputObj = { mailSablonuId: _mailSablonuId, konu: _konu, govde: _govde };

            console.log('SERVICE CALL - UpdateMailSablonu', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/UpdateMailSablonu', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async onizle(_konu: string, _govde: string) {
        try {
            var inputObj = { konu: _konu, govde: _govde };

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/Onizle', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async varsayilanaDon(_id: string) {
        try {
            var inputObj = { id: _id };

            console.log('SERVICE CALL - VarsayilanaDon', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/VarsayilanaDon', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async denemeGonder(_konu: string, _govde: string, _adres: string) {
        try {
            var inputObj = { konu: _konu, govde: _govde, adres: _adres };

            console.log('SERVICE CALL - DenemeGonder', JSON.stringify({ adres: _adres }));

            const resp = await axios.post(Helpers.getEndpoint() + '/MailSablonu/DenemeGonder', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
